module.exports = __webpack_public_path__ + "img/29c6a4c.png";